import { ReactNode, useEffect, useRef } from 'react';

import { api } from '@/api';
import { FCT } from '@/i18n';
import { useToastHandler } from '@/shared/hook';
import { Loading } from '@/shared/ui';
import { useAuthStore } from '@/store';

import { CONFIG } from '../config';
import { RoleGuard } from './role.guard';

interface UserStateProps {
  children: ReactNode;
}

export function UserState({ children }: UserStateProps) {
  const toastRef = useRef<HTMLSpanElement>(null);

  const { showUnauthenticatedToast } = useAuthStore();

  const toastHandler = useToastHandler({
    description: FCT.AUTHENTICATION.ERROR.DESCRIPTION,
    title: FCT.AUTHENTICATION.ERROR.TITLE,
    toastRef,
  });

  const { data, error, isError, isLoading } = api.pii.user.query.useGetUser();

  useEffect(() => {
    if (showUnauthenticatedToast) {
      toastHandler();
    }
  }, [showUnauthenticatedToast]);

  if (isLoading) {
    return <Loading />;
  }

  if (error && isError) {
    window.location.replace(`${CONFIG.APPS_SERVER}/login?redirectUrl=${window.location.href}`);

    return null;
  }

  return <RoleGuard user={data!.user}>{children}</RoleGuard>;
}
